import React from 'react';
import { Link } from 'react-router-dom';

const Cookies = () => {
  return (
    <div className="legal-page">
      <h1>Cookie Policy</h1>
      <p className="last-updated">Last Updated: January 2024</p>

      <h2>1. Introduction</h2>
      <p>This Cookie Policy explains how Raix ("we," "our," or "us") uses cookies and similar technologies when you interact with our bot and website.</p>

      <h2>2. What Are Cookies?</h2>
      <p>Cookies are small text files that are placed on your device when you visit a website or use a service. They are widely used to make services work more efficiently.</p>

      <h2>3. How We Use Cookies</h2>
      <p>Raix may use cookies and similar technologies for:</p>
      <ul>
        <li>Session management</li>
        <li>Security features</li>
        <li>Performance analysis</li>
        <li>User preferences</li>
      </ul>

      <h2>4. Managing Cookies</h2>
      <p>You can control cookies through your browser settings. If you wish to stop all data collection by Raix, you can remove the Bot from your Discord server.</p>

      <h2>5. Contact Us</h2>
      <p>If you have any questions about our use of cookies, please contact us at:</p>
      <p>Email: <a href="mailto:factsonly9667@gmail.com">factsonly9667@gmail.com</a><br/>
      Discord: <a href="https://discord.gg/5tUh6aktZw" target="_blank" rel="noopener noreferrer">Join our support server</a></p>

      <div style={{ marginTop: '4rem' }}>
        <Link to="/" className="btn-secondary">Back to Home</Link>
      </div>
    </div>
  );
};

export default Cookies;
